/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BreakdownItem,
    BreakdownItemFromJSON,
    BreakdownItemFromJSONTyped,
    BreakdownItemToJSON,
} from './BreakdownItem';

/**
 * 
 * @export
 * @interface IntervalPropertyBreakdownByZone
 */
export interface IntervalPropertyBreakdownByZone {
    /**
     * 
     * @type {string}
     * @memberof IntervalPropertyBreakdownByZone
     */
    zoneName: string;
    /**
     * 
     * @type {number}
     * @memberof IntervalPropertyBreakdownByZone
     */
    zoneId: number;
    /**
     * 
     * @type {number}
     * @memberof IntervalPropertyBreakdownByZone
     */
    deviceId: number;
    /**
     * 
     * @type {number}
     * @memberof IntervalPropertyBreakdownByZone
     */
    sceneId: number;
    /**
     * 
     * @type {Array<BreakdownItem>}
     * @memberof IntervalPropertyBreakdownByZone
     */
    items: Array<BreakdownItem>;
}

export function IntervalPropertyBreakdownByZoneFromJSON(json: any): IntervalPropertyBreakdownByZone {
    return IntervalPropertyBreakdownByZoneFromJSONTyped(json, false);
}

export function IntervalPropertyBreakdownByZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntervalPropertyBreakdownByZone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zoneName': json['zone_name'],
        'zoneId': json['zone_id'],
        'deviceId': json['device_id'],
        'sceneId': json['scene_id'],
        'items': ((json['items'] as Array<any>).map(BreakdownItemFromJSON)),
    };
}

export function IntervalPropertyBreakdownByZoneToJSON(value?: IntervalPropertyBreakdownByZone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zone_name': value.zoneName,
        'zone_id': value.zoneId,
        'device_id': value.deviceId,
        'scene_id': value.sceneId,
        'items': ((value.items as Array<any>).map(BreakdownItemToJSON)),
    };
}

